import React from 'react';
import ReactFlow, { MiniMap, Controls, Background } from 'reactflow';
import { useNavigate } from 'react-router-dom';
import 'reactflow/dist/style.css';

const nodeStyle = {
  padding: '0px',
  fontSize: '15px',
  textAlign: 'center',
  borderRadius: '4px',
  margin:'0px'
  // border: '1px solid #ddd',
  // background: '#fff'
};

const FlowChart = ({height,width,bg}) => {
  const navigate = useNavigate();

  const initialNodes = [
    { id: '1', type: 'input', data: { label: <div onClick={() => navigate('/octobersky/kla')} className='cursor-pointer bg-blue-500 text-white hover:scale-x-105 hover:bg-blue-600' style={nodeStyle}>KLA</div> }, position: { x: 500, y: -450 } },
    { id: '2', data: { label: <div onClick={() => navigate('/octobersky/session')} className='cursor-pointer bg-blue-500 text-white hover:scale-x-105 hover:bg-blue-600' style={nodeStyle}>Session</div> }, position: { x: 750, y: -450 } },
    { id: '3', type: 'input', data: { label: <div onClick={() => navigate('/octobersky/events')} className='cursor-pointer bg-gray-500 text-white hover:scale-x-105 hover:bg-gray-600' style={nodeStyle}>Event</div> }, position: { x: 1250, y: -450 } },
    { id: '4', data: { label: <div onClick={() => navigate('/octobersky/constituency-mapping')} className='bg-blue-500 cursor-pointer text-white hover:scale-x-105 hover:bg-blue-600' style={nodeStyle}>Constituency Mapping</div> }, position: { x: 750, y: -250 } },
    { id: '5', data: { label: <div onClick={() => navigate('/octobersky/session/member-mapping')} className='bg-blue-500 cursor-pointer text-white hover:scale-x-105 hover:bg-gray-600' style={nodeStyle}>Member Mapping</div> }, position: { x: 750, y: -50 } },
    { id: '6', type: 'input', data: { label: <div onClick={() => navigate('/octobersky/constituency')} className='cursor-pointer bg-gray-500 text-white hover:scale-x-105 hover:bg-gray-600' style={nodeStyle}>Constituency</div> }, position: { x: 500, y: -300 } },
    { id: '7', type: 'input', data: { label: <div onClick={() => navigate('/octobersky/reservation')} className='cursor-pointer bg-gray-500 text-white hover:scale-x-105 hover:bg-gray-600' style={nodeStyle}>Reservation</div> }, position: { x: 500, y: -250 } },
    { id: '8', type: 'input', data: { label: <div onClick={() => navigate('/octobersky/salutation')} className='cursor-pointer bg-gray-500 text-white hover:scale-x-105 hover:bg-gray-600' style={nodeStyle}>Salutation</div> }, position: { x: 500, y: -150 } },
    { id: '9', type: 'input', data: { label: <div onClick={() => navigate('/octobersky/members')} className='cursor-pointer bg-gray-500 text-white hover:scale-x-105 hover:bg-gray-600' style={nodeStyle}>Member</div> }, position: { x: 500, y: -100 } },
    { id: '10', type: 'input', data: { label: <div onClick={() => navigate('/octobersky/role')} className='cursor-pointer bg-gray-500 text-white hover:scale-x-105 hover:bg-gray-600' style={nodeStyle}>Role</div> }, position: { x: 500, y: -50 } },
    { id: '11', type: 'input', data: { label: <div style={nodeStyle}>Designation</div> }, position: { x: 500, y: 0 } },
    { id: '12', type: 'output', data: { label: <div className='flex flex-col gap-2' style={nodeStyle}>
       <button onClick={() => navigate('/octobersky/video')} className='bg-blue-500 cursor-pointer text-white hover:scale-x-105 hover:bg-blue-600 rounded'>Video</button> 
       <button onClick={() => navigate('/octobersky/governersaddress')} className='bg-blue-500 cursor-pointer text-white hover:scale-x-105 hover:bg-blue-600 rounded'>Governer's address</button>
       <button onClick={() => navigate('/octobersky/budget-speech')} className='bg-blue-500 cursor-pointer text-white hover:scale-x-105 hover:bg-blue-600 rounded'>Budget speech</button>
       <button onClick={() => navigate('/octobersky/rulings')} className='bg-blue-500 cursor-pointer text-white hover:scale-x-105 hover:bg-blue-600 rounded'>Rulings</button>
        </div> }, position: { x: 1000, y: -200 } },
    { id: '13', type: 'input', data: { label: <div style={nodeStyle}>Tag</div> }, position: { x: 1250, y: -200 } },
    { id: '14', data: { label: <div onClick={() => navigate('/octobersky/session/sittings')} className='bg-blue-500 cursor-pointer text-white hover:scale-x-105 hover:bg-blue-600' style={nodeStyle}>Sittings</div> }, position: { x: 1000, y: -450 } },
  ];

  const initialEdges = [
    // Add your edges here if needed
    //constituency mapping
    { id: 'e1-4', source: '1', target: '4', animated: true },
    { id: 'e6-4', source: '6', target: '4', animated: true },
    { id: 'e7-4', source: '7', target: '4', animated: true },
    // member mapping
    { id: 'e8-5', source: '8', target: '5', animated: true },
    { id: 'e9-5', source: '9', target: '5', animated: true },
    { id: 'e10-5', source: '10', target: '5', animated: true },
    { id: 'e11-5', source: '11', target: '5', animated: true },
    // kla to session
    { id: 'e1-2', source: '1', target: '2', animated: true },
    // session to sitting
    { id: 'e2-14', source: '2', target: '14', animated: true },
    // add video
    { id: 'e1-12', source: '1', target: '12', animated: true },
    { id: 'e2-12', source: '2', target: '12', animated: true },
    { id: 'e3-12', source: '3', target: '12', animated: true },
    { id: 'e5-12', source: '5', target: '12', animated: true },
    { id: 'e14-12', source: '14', target: '12', animated: true },
    // constituency mapping to member mapping 
    { id: 'e4-5', source: '4', target: '5', animated: true },
    // tag to video
    { id: 'e13-12', source: '13', target: '12', animated: true },
  ];

  return (
    <div className='overflow-hidden flex justify-center items-center w-full h-full'>
      <div style={{ width: width, height: height}}>
        <ReactFlow
          nodes={initialNodes}
          edges={initialEdges}
          fitView
          nodesDraggable={false}
          nodesConnectable={false}
          elementsSelectable={true}
        >
          <MiniMap />
          <Controls />
          {bg==true&&<Background />}
        </ReactFlow>
      </div>
    </div>
  );
};

export default FlowChart;
